import React, { useEffect, useState } from 'react';
import { chargerPhoto } from '../donnees/collectes';

/* Vignette d'une photo de collecte. Le fichier n'est lisible qu'avec le jeton
   client (GET /blobs/images/{nom}) : il est chargé en blob puis affiché par
   une URL locale, libérée au démontage. Un clic l'ouvre en grand. */
const PhotoCollecte: React.FC<{ nom: string; legende: string; taille?: number; hauteur?: number }> = ({ nom, legende, taille = 64, hauteur }) => {
  const [url, setUrl] = useState<string | null>(null);
  const [echec, setEchec] = useState(false);

  useEffect(() => {
    let actif = true;
    let locale: string | null = null;
    chargerPhoto(nom)
      .then(blob => {
        if (!actif) return;
        locale = URL.createObjectURL(blob);
        setUrl(locale);
      })
      .catch(() => { if (actif) setEchec(true); });
    return () => {
      actif = false;
      if (locale) URL.revokeObjectURL(locale);
    };
  }, [nom]);

  const cadre: React.CSSProperties = {
    width: taille, height: hauteur ?? taille, borderRadius: 'var(--rayon-petit)', border: 'var(--trait-fin)',
    background: 'var(--bloc-alterne)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    overflow: 'hidden', flexShrink: 0,
  };

  if (echec) return <span style={cadre} className="petit texte-secondaire" title={legende}>Photo indisponible</span>;
  if (!url) return <span style={cadre} aria-label={`${legende} (chargement)`} role="img"><span className="roue" aria-hidden /></span>;
  return (
    <a href={url} target="_blank" rel="noreferrer" style={cadre} title="Ouvrir la photo en grand">
      <img src={url} alt={legende} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
    </a>
  );
};

export default PhotoCollecte;
